const Microphone = {
  "label"   : "Preference",
  "options" : [
    "Microphone",
    "No Microphone"
  ]
}

export default Microphone